import type { InvariantJiraRoute } from '@atlassian/jira-route-types/src/InvariantJiraRoute.tsx';

export const classicBusinessProjectFormRoute: InvariantJiraRoute = {
	name: 'classic-business-form',
	path: '/jira/core/projects/:projectKey/form',
	exact: true,
};
